module.exports = __webpack_public_path__ + "static/media/access_banner.a6d0532d.png";